import { render, staticRenderFns } from "./ScreeningUnUpdate.vue?vue&type=template&id=2ced9c03&scoped=true&"
import script from "./ScreeningUnUpdate.vue?vue&type=script&lang=js&"
export * from "./ScreeningUnUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningUnUpdate.vue?vue&type=style&index=0&id=2ced9c03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced9c03",
  null
  
)

export default component.exports